import CryptoJS from 'crypto-js';

// Function to encrypt and store data
export const encryptAndStoreData = (key, data, secretKey) => {
    const dataToEncrypt = typeof data === 'string' ? data : JSON.stringify(data); // Convert to string if not already
    const encryptedData = CryptoJS.AES.encrypt(dataToEncrypt, secretKey).toString();
    localStorage.setItem(key, encryptedData);
};

// Function to decrypt and retrieve data
export const decryptAndRetrieveData = (key, secretKey) => {
    const encryptedData = localStorage.getItem(key);
    if (!encryptedData) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    // Try parsing the decrypted data as JSON; return the string if it's not JSON
    try {
        return JSON.parse(decryptedData);
    } catch (error) {
        return decryptedData; // Return the raw string if it's not JSON
    }
};
